import { get, post } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'client-support-plans';

const apiClientSupportPlans = 'DEPRECATED/api/clients/support-plans';

const config = [
  { actionType: 'getAll', apiPath: apiClientSupportPlans, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiClientSupportPlans}/${params.id}`, method: get },
  { actionType: 'create', apiPath: apiClientSupportPlans, method: post },
  { actionType: 'getAvailableClients', apiPath: `${apiClientSupportPlans}/available-clients`, method: get },
];

export const { getAll, getOne, create, getAvailableClients } = createThunks(typePrefix, config);
